// Function to emphasize headlines, convert "**" to <strong>, and handle "br" and "br/"
function emphasizeHeadlines() {
    // Retrieve the value of the CSS custom property --emphasize-headline
    const emphasizeClass = getComputedStyle(document.documentElement).getPropertyValue('--emphasize-headline').trim();

    // Select all headings (h1 through h5)
    const headings = document.querySelectorAll('h1:not([data-headline-formatted]), h2:not([data-headline-formatted]), h3:not([data-headline-formatted]), h4:not([data-headline-formatted]), h5:not([data-headline-formatted])');

    headings.forEach(heading => {
        // Work on text nodes so existing <br> tags and attributes are never rewritten.
        const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
        const textNodes = [];
        while (walker.nextNode()) textNodes.push(walker.currentNode);
        textNodes.forEach(node => {
            if (node.parentElement.closest('script, style')) return;
            const encoded = escapeHeadlineText(node.textContent);
            const formatted = encoded.replace(/\bbr\/?(?!\w)|\*\*(.+?)\*\*|\*([^*]+?)\*/g, (match, strong, emphasis) => strong !== undefined ? `<strong>${strong.trim()}</strong>` : emphasis !== undefined ? `<span class="${emphasizeClass}">${emphasis.trim()}</span>` : '<br>');
            if (formatted === encoded) return;
            const template = document.createElement('template');
            template.innerHTML = formatted;
            node.replaceWith(template.content);
        });


    });
}

function escapeHeadlineText(text) {
    const element = document.createElement('span');
    element.textContent = text;
    return element.innerHTML;
}

// Call the function after DOM is loaded
document.addEventListener('DOMContentLoaded', emphasizeHeadlines);

function initEurolandIframes() {
    const iframe = document.getElementById('external-tool');
    if (!iframe) {
        return;
    }
    if (window.EurolandToolIntegrationObject && typeof window.EurolandToolIntegrationObject.set === 'function') {
        window.EurolandToolIntegrationObject.set('external-tool');
        return;
    }
    // Load the external integration only on pages that actually contain its iframe.
    const script = document.createElement('script');
    script.src = 'https://tools.euroland.com/tools/common/eurolandiframeautoheight/eurolandtoolsintegrationobject.js';
    script.async = true;
    script.addEventListener('load', () => {
        if (window.EurolandToolIntegrationObject && typeof window.EurolandToolIntegrationObject.set === 'function') {
            window.EurolandToolIntegrationObject.set('external-tool');
        }
    });
    document.head.appendChild(script);
}

document.addEventListener('DOMContentLoaded', initEurolandIframes);
